import React, {useState} from 'react';
import {getSupportedLanguages} from '../../common/i18n/config';

interface FieldLanguageSwitcherProps {
  currentLanguage: string;
  onLanguageChange: (language: string) => void;
  collapsed?: boolean;
  translatedLanguages?: string[];
}

const FieldLanguageSwitcher: React.FC<FieldLanguageSwitcherProps> = ({
                                                                       currentLanguage,
                                                                       onLanguageChange,
                                                                       collapsed = false,
                                                                       translatedLanguages = []
                                                                     }) => {
  const [isExpanded, setIsExpanded] = useState(!collapsed);
  const supportedLanguages = getSupportedLanguages();
  const hasOtherTranslations = translatedLanguages.some(lang => lang !== currentLanguage);

  if (isExpanded) {
    return (
      <div className="flex items-center gap-1 h-6">
        {supportedLanguages.map((langCode) => {
          const hasTranslation = translatedLanguages.includes(langCode);
          return (
            <button
              key={langCode}
              type="button"
              onClick={() => onLanguageChange(langCode)}
              className={`text-xs px-1 py-0.5 rounded transition-colors ${
                langCode === currentLanguage
                  ? (hasTranslation ?
                    'bg-gray-700 text-white font-bold'
                    : 'bg-gray-700 text-white')
                  : (hasTranslation
                    ? 'text-gray-700 font-bold hover:text-gray-900 hover:bg-gray-100'
                    : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100')
              }`}
            >
              {langCode}
            </button>
          );
        })}
        {collapsed && (
          <button
            type="button"
            onClick={() => setIsExpanded(false)}
            className="text-gray-400 hover:text-gray-600 ml-1"
          >
            <i className="fa fa-angle-right text-xs"></i>
          </button>
        )}
      </div>
    );
  }

  const hasCurrentLanguage = translatedLanguages.includes(currentLanguage);
  const otherTranslationsCount = translatedLanguages.filter(lang => lang !== currentLanguage).length;

  return (
    <button
      type="button"
      onClick={() => setIsExpanded(true)}
      className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-700 h-6"
    >
      <span className={`${hasCurrentLanguage ? 'font-bold' : ''}`}>{currentLanguage}</span>
      <span>|</span>
      {hasOtherTranslations ? (
        // <i className="mr-1 text-[0.4rem] fa fa-circle text-gray-500 hover:text-gray-700"></i>
        // <span className="text-xs px-1 py-0.5 rounded bg-gray-700 text-white font-bold">
        //   {otherTranslationsCount}
        // </span>
        <i className="fa fa-angles-left"></i>
      ) : (
        <i className="fa fa-angle-left"></i>
      )}
    </button>
  );
};

export default FieldLanguageSwitcher;

